import { purchaseOrderIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deletePurchaseOrder = {
  name: "deletePurchaseOrder" as const,
  input: z.object({ purchaseOrderId: purchaseOrderIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
